import { InPlay } from '@ps/isp-web-component-library/icons/InPlay';
import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import type { IceHockeyFixture, IceHockeyPeriod } from '@ps/web-shared-generated-graphql/sports';

import EventStatusMessage from '../../EventStatusMessage/EventStatusMessage';
import FormatEventStatusDuration from '../FormatEventStatusDuration/FormatEventStatusDuration';
import GameTime from '../GameTime/GameTime';

import {
  TXTWCL_End_of_Overtime,
  TXTWCL_End_of_P1,
  TXTWCL_End_of_P2,
  TXTWCL_End_of_P3,
  TXTWCL_Game_Ended,
  TXTWCL_Overtime,
  TXTWCL_P1,
  TXTWCL_P2,
  TXTWCL_P3,
  TXTWCL_Penalties
} from './IceHockeyScoreboardInPlayStatus.messages.json';

const translationMap: Record<IceHockeyPeriod, TranslationTag> = {
  PERIOD_1: TXTWCL_P1,
  PERIOD_2: TXTWCL_P2,
  PERIOD_3: TXTWCL_P3,
  END_PERIOD_1: TXTWCL_End_of_P1,
  END_PERIOD_2: TXTWCL_End_of_P2,
  END_PERIOD_3: TXTWCL_End_of_P3,
  OVERTIME: TXTWCL_Overtime,
  END_OVERTIME: TXTWCL_End_of_Overtime,
  END: TXTWCL_Game_Ended,
  PENALTIES: TXTWCL_Penalties
};

interface Props {
  iceHockeyFixture: IceHockeyFixture;
}

const IceHockeyScoreboardInPlayStatus: React.FC<Props> = ({ iceHockeyFixture }) => {
  const { score, clock } = iceHockeyFixture;

  if (!score || !clock) {
    return <EventStatusMessage messageId="IN_PLAY" icon={InPlay} size="XSmall" />;
  }

  switch (clock.period) {
    case 'END':
    case 'END_PERIOD_1':
    case 'END_PERIOD_2':
    case 'END_PERIOD_3':
    case 'END_OVERTIME':
    case 'PENALTIES':
      return (
        <GameTime>
          <span>
            <Translation {...translationMap[clock.period]} />
          </span>
        </GameTime>
      );
    case 'PERIOD_1':
    case 'PERIOD_2':
    case 'PERIOD_3':
    case 'OVERTIME':
      return (
        <GameTime>
          <span>
            <Translation {...translationMap[clock.period]} />
            <FormatEventStatusDuration intervalInSeconds={clock.timeRemaining} isCountdownTimer />
          </span>
        </GameTime>
      );
    default:
      return <EventStatusMessage messageId="IN_PLAY" icon={InPlay} size="XSmall" />;
  }
};

export default IceHockeyScoreboardInPlayStatus;
